import React from 'react';
import QueryManager from 'src/lib/managers/QueryManager';
import Head from 'src/components/Head/Head';
import { connect } from 'react-redux';
import { setIsLoadingProducts } from 'src/lib/redux/modules/search';
import { getCurrentTheme } from 'src/lib/redux/modules/settings';
import Header from 'src/components/Header/Header';
import dynamic from 'next/dynamic';
import NewsLetters from '../NewsLetters/NewsLetters';
import withParsedQuery from 'src/lib/hoc/withParsedQuery';
import { SEARCH } from 'src/lib/constants/routes';
import TrackingManager from 'src/lib/managers/TrackingManager';

const Footer = dynamic(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "footer" */ 'src/components/Footer/Footer'), {
	ssr: false,
});

@connect(
	state => ({
		currentTheme: getCurrentTheme(state.settings),
	}),
	dispatch => ({
		dispatch,
	})
)
@withParsedQuery()
class StaticPageLayout extends React.Component {
	state = {
		categoryListIsOpen: false,
		queryParams: {},
	};

	submitQuery = query => {
		const { pageTitle } = this.props;
		const { parsedQuery } = this.props;
		delete parsedQuery['q'];
		delete parsedQuery['zby'];
	
		TrackingManager.trackOnNav('search', {
			keyword: query,
			cid: parsedQuery.cid,
			action: 'search',
			section: pageTitle,
		});
		location.href = `${SEARCH}?${QueryManager.stringify(parsedQuery)}&q=${query}&page=1`;
	};

	componentDidMount = () => {
		this.props.dispatch(setIsLoadingProducts(false));
	};

	render() {
		const { children, pageTitle, currentTheme } = this.props;

		return (
			<div className={`${currentTheme}-theme`}>
				<Head pageTitle={pageTitle} />
				<Header isFilterButton={false} onSearch={this.submitQuery} />
				{children}
				<NewsLetters />
				<Footer />
			</div>
		);
	}
}

export default StaticPageLayout;
